import { Box, Button, FlexBox, Tabs } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import type { ConversationDirection } from 'lib-shared-types-api';
import { ComponentProps, useState } from 'react';

import styles from './conversationReply.module.scss';

/** Represents the available tab types. */
type Tab = Extract<ConversationDirection, 'outbound' | 'internal'>;

/** Represents the reply section tabs. */
const tabs: ComponentProps<typeof Tabs>['tabs'] = [
  { id: 'outbound', label: 'Answer' },
  { id: 'internal', label: 'Internal note' },
];

const accentColors: Record<Tab, keyof typeof colors> = {
  outbound: 'neutral',
  internal: 'orange',
};

/** Represents the reply section of the conversation main view. */
export const ConversationReply = (): JSX.Element => {
  const [replyTabId, setReplyTabId] = useState<Tab>('outbound');
  const accentColor = accentColors[replyTabId];

  return (
    <FlexBox
      className={styles.root}
      flexDirection="column"
      borderRadius="100"
      borderColor={colors[accentColor][200]}
    >
      <FlexBox
        className={styles.header}
        gap="200"
        alignItems="center"
        justifyContent="space-between"
        padding="0 300"
        background={colors[accentColor][100]}
      >
        <Tabs
          selectedId={replyTabId}
          tabs={tabs}
          onChange={(tabId) => setReplyTabId(tabId as Tab)}
        />

        <Button variant="tertiary">Actions</Button>
      </FlexBox>

      <Box flex="1">{replyTabId}</Box>
    </FlexBox>
  );
};
